'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFieldContentBoxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Define label position
   */
  labelPosition: _propTypes2.default.oneOf(['top', 'side'])
};

var defaultProps = {
  labelPosition: 'top'
};

/** PROP RECEIVERS */
var contentFlow = function contentFlow(_ref) {
  var labelPosition = _ref.labelPosition;
  return labelPosition === 'top' ? 'flex-direction: column;' : 'flex-direction: row;';
};

/** STYLES */
/** ex textfield-content-box */
var TextFieldContentBoxStyled = exports.TextFieldContentBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TextFieldContentBoxStyled'
})(['display:flex;position:relative;max-width:100%;', ';'], contentFlow);

TextFieldContentBoxStyled.propTypes = propTypes;
TextFieldContentBoxStyled.defaultProps = defaultProps;
TextFieldContentBoxStyled.displayName = 'TextFieldContentBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/TextFieldContentBoxStyled.js
// module id = 850
// module chunks = 0